import { useSelector } from "react-redux";

export const useFreeProxyData = () => {
  const {
    freeProxies,
    cities,
    paginationData,
    isLoading,
    isProxyLoaded,
    isOpenDropDown,
    clearSelectedCountry,
    isFreeProxiesForExportLoaded,
    freeProxiesForExport,
    isFirstRender,
  } = useSelector(state => state.freeProxy);

  return {
    freeProxies,
    cities,
    paginationData,
    isLoading,
    isProxyLoaded,
    isOpenDropDown,
    clearSelectedCountry,
    isFreeProxiesForExportLoaded,
    freeProxiesForExport,
    isFirstRender,
  };
};
